import React from "react";
import { Content } from "./Content";
import { Header } from "../../Header";
import style from "../style.module.scss";
import "../SpectrophotometerInfoModal/style.scss";
import { LabManual } from "@learningblocks/simulations/shared-components/lib/LabManual";

/**
 * Props for the SpectrophotometerManualModal component
 */
interface SpectrophotometerManualModalProps {
  /**
   * Whether the modal window is open
   */
  isOpen: boolean;
  /**
   * Function to call when closing the modal window
   */
  onClose: () => void;
  /**
   * Whether the notebook is collapsed
   */
  notebookCollapsed: boolean;
  /**
   * size of  header
   */
  size: "sm" | "md" | "lg";
}

/**
 * SpectrophotometerManualModal:
 *  - Give user general info on Spectrophotometer and
 *    its working
 */
export function SpectrophotometerManualModal(
  props: SpectrophotometerManualModalProps
) {
  return (
    <LabManual
      isOpen={props.isOpen}
      className={style.manualModal}
      notebookExpanded={!props.notebookCollapsed}
      closeButton={true}
      onClose={props.onClose}
      alignLeft={true}
    >
      <div className={style.container}>
        <Header
          className={style.header}
          label="How to measure sample absorbance"
          size={props.size}
        />
        <div className={style.section}>
          <Content />
        </div>
      </div>
    </LabManual>
  );
}

SpectrophotometerManualModal.defaultProps = {
  isOpen: false,
  size: "lg",
};
